import { useNavigate } from 'react-router-dom';

const AuthError = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#160C0C] text-white">
      <div className="text-center max-w-md mx-auto px-6">
        <div className="text-red-500 text-6xl mb-6">⚠️</div>
        <h1 className="text-2xl font-bold mb-4">
          Erro na Verificação
        </h1>
        <p className="text-gray-300 mb-8 leading-relaxed">
          Ocorreu um erro ao verificar seu email. O link pode ter expirado ou ser inválido.
        </p>
        <div className="space-y-4">
          <button
            onClick={() => navigate('/')}
            className="w-full bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            Voltar ao Início
          </button>
          <button
            onClick={() => navigate('/dashboard')}
            className="w-full bg-gray-700 text-white px-6 py-3 rounded-lg hover:bg-gray-600 transition-colors font-medium"
          >
            Ir para Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthError;


